import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import logoVerticalWhite from '@/assets/logo-vertical-white.svg';

import { useAuth } from '../contexts/AuthContext';

import { MobileMenu } from './MobileMenu';

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 transition-all duration-300 ${
        isScrolled ? 'backdrop-premium py-4' : 'bg-transparent py-6'
      }`}
      style={{ zIndex: isMobileMenuOpen ? 9997 : 50 }}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src={logoVerticalWhite} 
              alt="BlackRent Autoservis" 
              width="180"
              height="56"
              className="h-12 md:h-14 transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              Domov
            </Link>
            <Link
              to="/cennik"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              Cenník
            </Link>
            <Link
              to="/nahradne-vozidla"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              Náhradné vozidlá
            </Link>
            {/* Galéria - skryté kým nemáme vlastné fotky */}
            {/* <Link
              to="/galerija"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              Galéria
            </Link> */}
            <Link
              to="/o-nas"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              O nás
            </Link>
            <Link
              to="/kontakt"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              Kontakt
            </Link>
            <Link
              to="/faq"
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
            >
              FAQ
            </Link>
            {isAuthenticated ? (
              <Link
                to="/dashboard"
                className="text-sm font-medium text-gold-500 hover:text-gold-400 transition-colors duration-200"
              >
                Dashboard
              </Link>
            ) : (
              <Link
                to="/login"
                className="text-sm font-medium text-gray-300 hover:text-white transition-colors duration-200"
              >
                Prihlásenie
              </Link>
            )}
          </nav>

          {/* CTA Button */}
          <div className="flex items-center space-x-4">
            {/* Booking Button - Direct Link */}
            <Link
              to="/rezervacia"
              className="hidden lg:block btn-primary text-sm px-6 py-3"
            >
              Rezervovať
            </Link>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              className="lg:hidden p-2 text-white hover:text-gold-500 transition-colors"
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </header>
  );
}
